import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import { SpotForContentsEditFragmentDoc } from '../../../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FetchCourseQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type FetchCourseQuery = { __typename?: 'QueryRoot', course: { __typename?: 'Course', id: string, name: string, spots: Array<{ __typename?: 'Spot', id: string, parentSpotId?: string | null, spotType: Types.SpotType, order: number, name?: string | null, description?: string | null, geofenceRadius: number, narrationText?: string | null, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, hasRestaurant: boolean, hasEvCharger: boolean, musicQuestion?: string | null, narrationTextForTtsBeforeMusic?: string | null, narrationTextForTtsAfterMusic?: string | null, note?: string | null, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } }> } };


export const FetchCourseDocument = gql`
    query FetchCourse($id: String!) {
  course(id: $id) {
    id
    name
    spots {
      ...SpotForContentsEdit
    }
  }
}
    ${SpotForContentsEditFragmentDoc}`;

export function useFetchCourseQuery(options: Omit<Urql.UseQueryArgs<FetchCourseQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchCourseQuery, FetchCourseQueryVariables>({ query: FetchCourseDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFetchCourseQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ course })
 *   )
 * })
 */
export const mockFetchCourseQuery = (resolver: ResponseResolver<GraphQLRequest<FetchCourseQueryVariables>, GraphQLContext<FetchCourseQuery>, any>) =>
  graphql.query<FetchCourseQuery, FetchCourseQueryVariables>(
    'FetchCourse',
    resolver
  )
